function HomepageSection(props) {
    
    return (
        <section className={`homepage-section`}>
            <h2 className={`section-subheading homepage-section-${props.name}__subheading`}>{props.sectionHeading}</h2>
            {props.overviewText}
         </section>
    )
}

export { HomepageSection }